import {SiteFooter} from '../components/SiteFooter';
import {SiteHeader} from '../components/SiteHeader';

export const AboutPage = () => (
  <div className="newspaper">
    <SiteHeader />
    <main className="about-page shell" id="main-content">
      <header className="about-page__header">
        <span className="eyebrow">The publication</span>
        <h1>About the Chicago Sentinel Times</h1>
        <p>Independent metropolitan journalism and civic information, organized for people who want to understand Chicago.</p>
      </header>

      <div className="about-page__grid">
        <section className="about-page__introduction" aria-labelledby="our-purpose">
          <h2 id="our-purpose">Our purpose</h2>
          <p>The Chicago Sentinel Times is a digital newspaper focused on the city, its neighborhoods and the institutions that shape daily life. The publication brings together local reporting, clearly attributed public information and useful coverage from trusted outside publishers.</p>
          <p>Our aim is a restrained, readable and accountable metropolitan news experience—one that makes sources and story ownership clear.</p>
        </section>

        <aside aria-label="Coverage areas" className="about-page__coverage">
          <h2>Coverage</h2>
          <ul>
            <li>Chicago and its neighborhoods</li>
            <li>Politics and civic life</li>
            <li>Business and the local economy</li>
            <li>Science and technology</li>
            <li>Culture and sports</li>
            <li>Investigations and accountability</li>
          </ul>
        </aside>
      </div>

      <section className="about-page__standards" id="standards" aria-labelledby="editorial-standards">
        <span className="eyebrow">Transparency</span>
        <h2 id="editorial-standards">Editorial standards</h2>
        <div>
          <p><strong>Clear provenance.</strong> External reporting links to its canonical publisher and displays source attribution. Sentinel originals appear as complete articles on this site.</p>
          <p><strong>Responsible public information.</strong> Weather, public records and civic information retain their source and update time. We do not fabricate real breaking news, official notices, alerts, election results or quotes from real people.</p>
          <p><strong>Creative material.</strong> Some Sentinel-owned features may contain fictional or creative editorial material. That work is governed, appropriately labeled and never presented as real breaking news.</p>
        </div>
      </section>

      <section className="about-page__contact" id="contact" aria-labelledby="contact-the-sentinel">
        <span className="eyebrow">Get in touch</span>
        <h2 id="contact-the-sentinel">Contact the Sentinel</h2>
        <p>Contact details for editorial questions, corrections and general inquiries will be published here as those channels become available.</p>
      </section>
    </main>
    <SiteFooter />
  </div>
);
